/* INTEGY V501 — verified local recommendation controller.
   Cards render immediately from compact local shards. Shopify product JSON refreshes
   image, price and stock in the background. Older Integy-hosted images are fallback-only,
   so a slow firewall image can no longer be the initial buyer-facing image. */
(function () {
  'use strict';
  if (window.IntegyV501Recommendations) return;
  var productCache = Object.create(null), shardCache = Object.create(null);
  var PLACEHOLDER = (window.INTEGY_V426_SEARCH && window.INTEGY_V426_SEARCH.placeholder) || '';
  var STORAGE_PREFIX = 'integy:v501:product:';
  function v626Root(){
    try { var r=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root; if(r) return r.charAt(r.length-1)==='/'?r:r+'/'; } catch(e) {}
    return '/';
  }
  function v626ProductUrl(handle){ return v626Root()+'products/'+encodeURIComponent(handle||''); }
  function readStored(handle){
    try {
      var raw=window.localStorage && localStorage.getItem(STORAGE_PREFIX+handle);
      if(!raw) return null;
      var item=JSON.parse(raw);
      if(!item || !item.ts || Date.now()-item.ts>43200000){ localStorage.removeItem(STORAGE_PREFIX+handle); return null; }
      return item.p || null;
    } catch(e){ return null; }
  }
  function writeStored(handle,p){
    try {
      if(!p || !window.localStorage) return;
      var v=firstVariant(p);
      var summary={
        handle:p.handle||handle,
        url:p.url||v626ProductUrl(handle),
        title:p.title||'',
        available:!!p.available,
        featured_image:imageFromProduct(p),
        images:p.images||[],
        variants:v?[{sku:v.sku||'',price:Number(v.price||0),compare_at_price:Number(v.compare_at_price||0),available:v.available!==false}]:[]
      };
      localStorage.setItem(STORAGE_PREFIX+handle,JSON.stringify({ts:Date.now(),p:summary}));
    } catch(e){}
  }

  function qsa(sel, scope) { try { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); } catch(e) { return []; } }

  function quarantineNative(scope){
    qsa('body.template-product .product-recommendations--section',scope||document).forEach(function(section){
      if(section.querySelector('[data-integy-v501-related-root]')) return;
      section.hidden=true; section.setAttribute('aria-hidden','true'); section.setAttribute('data-integy-v501-native-recommendations-hidden','true');
    });
    qsa('body.template-product [data-product-recommendations],body.template-product .product-recommendations--section .product-row',scope||document).forEach(function(node){
      if(node.closest && node.closest('[data-integy-v501-related-root]')) return;
      node.hidden=true; node.setAttribute('aria-hidden','true'); node.setAttribute('data-integy-v501-native-recommendations-hidden','true');
    });
  }
  function esc(value) { return String(value == null ? '' : value).replace(/[&<>\"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','\"':'&quot;',"'":'&#39;'}[c];}); }
  function hashHandle(s) { var h=5381, i=0; s=String(s||''); for(;i<s.length;i+=1){h=(((h<<5)+h)^s.charCodeAt(i))>>>0;} return h%128; }
  function pad3(n){ return ('000'+n).slice(-3); }
  function assetBase(){
    var tag=document.querySelector('script[src*="integy-v501-recommendations"]');
    return tag ? String(tag.src||'').replace(/integy-v501-recommendations(?:\.min)?\.js(?:\?.*)?$/,'') : '';
  }
  function getShard(handle){
    var key=String(hashHandle(handle));
    if(!shardCache[key]) shardCache[key]=fetch(assetBase()+'integy-v501-related-index-'+pad3(Number(key))+'.json',{credentials:'same-origin',cache:'force-cache'})
      .then(function(r){if(!r.ok) throw new Error('index '+r.status);return r.json();}).catch(function(){return {items:{}};});
    return shardCache[key];
  }
  function getProduct(handle, retry){
    if(!productCache[handle]) productCache[handle]=fetch(v626ProductUrl(handle)+'.js',{credentials:'same-origin',cache:'force-cache'})
      .then(function(r){if(!r.ok) throw new Error('product '+r.status);return r.json();})
      .catch(function(){
        if(retry!==false) return fetch(v626ProductUrl(handle)+'.js',{credentials:'same-origin',cache:'no-store'}).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});
        return null;
      });
    return productCache[handle];
  }
  function unpack(raw){
    if(Array.isArray(raw)) return {h:raw[0]||'',s:raw[1]||'',t:raw[2]||'',p:Number(raw[3]||0),a:raw[4]!==false,i:raw[5]||''};
    return raw||{};
  }
  function firstVariant(p){
    if(!p || !Array.isArray(p.variants)) return null;
    for(var i=0;i<p.variants.length;i+=1) if(p.variants[i] && p.variants[i].available) return p.variants[i];
    return p.variants[0]||null;
  }
  function money(cents){
    cents=Number(cents||0);
    try { if(window.Shopify && typeof window.Shopify.formatMoney==='function') return window.Shopify.formatMoney(cents, window.Theme && Theme.moneyFormat); } catch(e){}
    try { return new Intl.NumberFormat('en-US',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'}).format(cents/100); } catch(e){}
    return '$'+(cents/100).toFixed(2);
  }
  function imageFromProduct(p){
    if(!p) return '';
    if(typeof p.featured_image==='string') return p.featured_image;
    if(p.featured_image && p.featured_image.src) return p.featured_image.src;
    if(Array.isArray(p.images) && p.images.length) return typeof p.images[0]==='string'?p.images[0]:(p.images[0]&&p.images[0].src)||'';
    return '';
  }
  function isShopifyImage(url){ return /(?:\/cdn\/shop\/|shopifycdn\.com|cdn\.shopify\.com)/i.test(String(url||'')); }
  function model(raw,p){
    var f=unpack(raw),stored=!p&&f.h?readStored(f.h):null,source=p||stored,v=firstVariant(source),live=!!source,liveImage=imageFromProduct(source),initial=isShopifyImage(f.i)?f.i:PLACEHOLDER;
    return {
      handle:(source&&source.handle)||f.h||'', url:(source&&source.url)||v626ProductUrl(f.h||''),
      title:(source&&source.title)||f.t||f.s||'Product', sku:(v&&v.sku)||f.s||'',
      image:liveImage||initial||f.i||'', fallback:f.i||'', price:v?Number(v.price||0):Number(f.p||0),
      compare:v&&Number(v.compare_at_price)>Number(v.price)?Number(v.compare_at_price):0,
      available:live?!!source.available:f.a!==false, live:live
    };
  }
  function cardMarkup(raw,index,p){
    var m=model(raw,p), available=m.available;
    return '<article class="integy-v501-related-card'+(available?'':' is-sold-out')+'" data-integy-v501-related-card data-product-handle="'+esc(m.handle)+'">'
      +'<a class="integy-v501-related-card__media-link" href="'+esc(m.url)+'" aria-label="'+esc(m.title)+'"><figure class="integy-v501-related-card__media">'
      +(m.image?'<img class="integy-v501-related-card__image" src="'+esc(m.image)+'" data-integy-v501-fallback-image="'+esc(m.fallback)+'" alt="'+esc(m.title)+'" width="600" height="600" loading="'+(index<2?'eager':'lazy')+'" decoding="async"'+(index===0?' fetchpriority="high"':'')+'>':'')
      +'</figure></a><div class="integy-v501-related-card__body"><h3 class="integy-v501-related-card__title"><a href="'+esc(m.url)+'">'+esc(m.title)+'</a></h3>'
      +(m.sku?'<div class="integy-v501-related-card__sku"><strong>SKU:</strong> '+esc(m.sku)+'</div>':'')
      +'<div class="integy-v501-related-card__price-row"><span class="integy-v501-related-card__price">'+esc(money(m.price))+'</span>'+(m.compare?'<s class="integy-v501-related-card__compare">'+esc(money(m.compare))+'</s>':'')+'</div>'
      +'<div class="integy-v501-related-card__stock '+(available?'is-in-stock':'is-out-of-stock')+'">'+(available?'In stock':'Out of stock')+'</div></div></article>';
  }
  function armImage(img){
    if(!img || img.dataset.integyV501FallbackBound==='true') return;
    img.dataset.integyV501FallbackBound='true';
    img.addEventListener('error',function(){
      var fallback=img.getAttribute('data-integy-v501-fallback-image')||'';
      if(fallback && img.dataset.integyV501FallbackStage!=='catalog'){
        img.dataset.integyV501FallbackStage='catalog'; img.src=fallback;
      } else if(PLACEHOLDER && img.src!==PLACEHOLDER){ img.dataset.integyV501FallbackStage='placeholder'; img.src=PLACEHOLDER; }
    });
  }
  function armImages(root){qsa('img[data-integy-v501-fallback-image]',root).forEach(armImage);}
  function empty(root){root.classList.remove('is-loading');root.classList.add('integy-v501-related-section--empty');root.setAttribute('aria-hidden','true');root.setAttribute('hidden','');root.removeAttribute('aria-busy');}
  function setHeading(root,entry){var h=root.querySelector('.product-recommendations--title');if(h)h.textContent=entry.m==='r'?(root.getAttribute('data-heading-related')||'Related parts & accessories'):(root.getAttribute('data-heading-compatible')||'More compatible parts');}
  function paint(root,entry,candidates){
    var grid=root.querySelector('[data-integy-v501-related-grid]');
    if(!grid||!candidates.length){empty(root);return;}
    setHeading(root,entry);
    grid.innerHTML=candidates.map(function(f,i){return cardMarkup(f,i,readStored(f.h));}).join('');
    armImages(grid);
    root.classList.remove('is-loading','integy-v501-related-section--empty');root.removeAttribute('hidden');root.setAttribute('aria-hidden','false');root.removeAttribute('aria-busy');root.setAttribute('data-integy-v501-related-loaded','true');root.setAttribute('data-integy-v501-recommendation-source','verified-local-shard');
    document.dispatchEvent(new CustomEvent('integy:v501:recommendations-rendered',{detail:{root:root,count:candidates.length,phase:'local'}}));
  }
  function revealFallback(root,raw){
    var f=unpack(raw),safeHandle=window.CSS&&CSS.escape?CSS.escape(f.h):String(f.h).replace(/[^a-zA-Z0-9_-]/g,'\\$&');
    var img=root.querySelector('[data-integy-v501-related-card][data-product-handle="'+safeHandle+'"] img');
    if(img && f.i && (!img.getAttribute('src') || img.getAttribute('src')===PLACEHOLDER)){img.dataset.integyV501FallbackStage='catalog';img.src=f.i;}
  }
  function refreshCard(root,raw,index){
    var f=unpack(raw),fallbackTimer=window.setTimeout(function(){revealFallback(root,f);},1200);
    getProduct(f.h,true).then(function(p){
      window.clearTimeout(fallbackTimer);
      if(!p){revealFallback(root,f);return;}writeStored(f.h,p);
      var safeHandle=window.CSS&&CSS.escape?CSS.escape(f.h):String(f.h).replace(/[^a-zA-Z0-9_-]/g,'\\$&');
      var old=root.querySelector('[data-integy-v501-related-card][data-product-handle="'+safeHandle+'"]');
      if(!old) return;
      var holder=document.createElement('div');holder.innerHTML=cardMarkup(f,index,p);var fresh=holder.firstElementChild;
      if(fresh){old.replaceWith(fresh);armImages(fresh);}
    }).catch(function(){window.clearTimeout(fallbackTimer);revealFallback(root,f);});
  }
  function load(root){
    if(!root || root.getAttribute('data-integy-v501-related-loaded')==='true') return;
    root.setAttribute('hidden','');root.setAttribute('aria-hidden','true');root.setAttribute('aria-busy','true');
    var handle=root.getAttribute('data-product-handle');if(!handle){empty(root);return;}
    getShard(handle).then(function(data){
      var entry=data&&data.items&&data.items[handle];if(!entry||!Array.isArray(entry.c)){empty(root);return;}
      var candidates=entry.c.map(unpack).filter(function(f){return f&&f.h&&f.a!==false;}).slice(0,5);
      if(!candidates.length) candidates=entry.c.map(unpack).filter(function(f){return f&&f.h;}).slice(0,5);
      if(!candidates.length){empty(root);return;}
      paint(root,entry,candidates);
      candidates.forEach(function(f,i){refreshCard(root,f,i);});
    }).catch(function(){empty(root);});
  }
  function init(scope){quarantineNative(scope||document);qsa('[data-integy-v501-related-root]',scope||document).forEach(load);}
  window.IntegyV501Recommendations=window.IntegyV500Recommendations=window.IntegyV499Recommendations=window.IntegyV495Recommendations={version:'V501',init:init,load:load,quarantineNative:quarantineNative};
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){init(document);},{once:true}); else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target||document);});
  window.addEventListener('pageshow',function(){init(document);},{passive:true});
})();
